export default "__VITE_ASSET__OE5AuX$C__"